{
  "attachAria": "Załącz plik",
  "emptyHint": "Opisz problem — pomoc odpowie tutaj",
  "emptyTitle": "Brak wiadomości",
  "fileOpenAria": "Otwórz załącznik",
  "logAria": "Rozmowa dotycząca zgłoszenia",
  "newMessages": "Nowe wiadomości",
  "placeholder": "Napisz wiadomość…",
  "placeholderDisabled": "Wiadomości są tymczasowo niedostępne",
  "previewAria": "Zobacz załącznik",
  "previewCloseAria": "Zamknij podgląd",
  "removeAttachmentAria": "Usuń plik",
  "retry": "Spróbuj ponownie",
  "screenshotAria": "Zrób zrzut ekranu",
  "seen": "Przeczytano",
  "sendAria": "Wyślij wiadomość",
  "sendFailed": "Nie udało się wysłać wiadomości",
  "sending": "Wysyłanie…",
  "student": "Uczeń",
  "supportName": "Pomoc Skyeng",
  "today": "Dzisiaj",
  "yesterday": "Wczoraj",
  "you": "Ty"
}
